/**
 * Pure computation functions for recipe detail page.
 * No React imports, no side effects.
 */

interface StepLike {
  id: string;
  depends_on: string[];
}

/** Compute the transitive closure of a step's dependencies (everything reachable from its direct deps). */
export function transitiveReachable(stepDeps: string[], allSteps: StepLike[]): Set<string> {
  const result = new Set<string>();
  for (const depId of stepDeps) {
    const queue = [depId];
    const visited = new Set<string>();
    while (queue.length) {
      const cur = queue.pop()!;
      if (visited.has(cur)) continue;
      visited.add(cur);
      const s = allSteps.find((x) => x.id === cur);
      for (const d of s?.depends_on ?? []) queue.push(d);
    }
    for (const id of visited) {
      if (id !== depId) result.add(id);
    }
  }
  return result;
}
